<canvas id="idCanvasPaq_{{this.indexI}}_{{this.indexJ}}" width="215" height="215">su navegador no soportado canvas</canvas>   